import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/react-start'
import {z} from 'zod'
import fetchHomePage from '~/client/sanity/fetchHomePage'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 * 3 // 3h

const homePageContentParams = z
    .object({
        locale: z.nativeEnum(Locale).optional(),
    })
    .optional()

const getHomePageContent = createServerFn({
    method: 'GET',
})
    .inputValidator((data: unknown) => {
        const result = homePageContentParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }

        return result.data
    })
    .handler(async ({data}) => {
        const {locale} = data ?? {}
        const homePageContent = await fetchHomePage(locale)

        applyServerFnCache(CACHE_TIME_SEC)

        return homePageContent
    })

export default getHomePageContent
